import React, { useState } from 'react'
import './index.scss'
import rightbtn from '@/assets/images/rightbtn.png'

const Setting = (props) => {
  let [cache] = useState('20M');
  let [newest] = useState('1.1.1');
  let { history } = props
  const handleGoService = () => {
    history.push('/service')
  }
  return (
    <div className="setting__box">
      <div className="setting-show">
        <div className="setting-con" onClick={handleGoService}>
          <span>法律条款与出行规则</span>
          <p><em><img src={rightbtn} alt="" /></em></p>
        </div>
        <div className="setting-con">
          <span>清空缓存</span>
          <p>{
            cache ? <b>{cache}<em><img src={rightbtn} alt="" /></em></b> :
              '缓存已清空'
          }</p>
        </div>
        <div className="setting-con">
          <span>当前版本<i>v1.0.0</i></span>
          <p>{
            newest ? <b>可更新至{newest}版本<em><img src={rightbtn} alt="" /></em></b> : '已是最新版本'
          }</p>
        </div>
      </div>
      <button className="quit-btn">退出登陆</button>
    </div>
  )
}
export default Setting